export const MAIN_COPY =
  'Tradespeople win more work by offering finance to clients. If you win ±5 jobs a year on finance, your subscription is already paid for.';
